import { React, useState, useEffect } from "react";

// components

import AdminNavbar from "../components/CMS/Navbars/AdminNavbar.js";
import Sidebar from "../components/CMS/Sidebar/Sidebar.js";
import HeaderWithoutStats from "../components/CMS/Headers/HeaderWithoutStats.js";
import FooterAdmin from "../components/CMS/Footers/FooterAdmin.js";
import Loader from "../components/CMS/Loader/Loader.js";

export default function Admin() {

  var slider1Url;
  var slider2Url;
  var slider3Url;
  var slider4Url;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  function validateLogin() {
    fetch(process.env.REACT_APP_API_BASE_LINK + '/v1/fookchong/cms/validate', {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
      },
    })
      .then(response => {
        if (response.status == 200) {
          // console.log("is true")
        } else {
          window.location.href = '/cms/admin/login';
        }
        // console.log(response)
      })
      .catch((e) => {
      });
  }
  // get slider img url from db
  useEffect(() => {
    validateLogin()
    getAllSlider()

  }, []);

  function getAllSlider() {
    fetch(process.env.REACT_APP_API_BASE_LINK + '/v1/fookchong/projects/banners')
      .then(response => response.json())
      .then((usefulData) => {
        setData(usefulData.data);
        setLoading(false);
        // console.log(usefulData.data)
      })
      .catch((error) => {
        alert("發生錯誤, 請重新載入")
      });
  }
  const coverImg_changed = (e, sliderId) => {
    var src = URL.createObjectURL(e.target.files[0]);
    document.getElementById(sliderId + "Img").setAttribute('src', src);
  }

  async function setSliderUrlById(url, sliderId) {

    if (sliderId === 'slider1')
      slider1Url = url
    if (sliderId === 'slider2')
      slider2Url = url
    if (sliderId === 'slider3')
      slider3Url = url
    if (sliderId === 'slider4')
      slider4Url = url
  }

  async function uploadSliderToImgur(file, sliderId) {

    // console.log(sliderId);
    // console.log(file);

    const formData = new FormData();
    formData.append("file", file);
    await fetch(process.env.REACT_APP_ESERVICE_HK_API_LINK, {
      method: "POST",
      body: formData,
    }).then((response) => response.json())
      .then((data) => {
        console.log(data)
        setSliderUrlById(data.url, sliderId)
      })
  }

  async function updateAllSlider() {

    var file1 = document.getElementById("slider1").files[0];
    var file2 = document.getElementById("slider2").files[0];
    var file3 = document.getElementById("slider3").files[0];
    var file4 = document.getElementById("slider4").files[0];

    if (file1 !== undefined)
      await uploadSliderToImgur(file1, "slider1");
    else
      slider1Url = document.getElementById("slider1Img").src;
    if (file2 !== undefined)
      await uploadSliderToImgur(file2, "slider2");
    else
      slider2Url = document.getElementById("slider2Img").src;
    if (file3 !== undefined)
      await uploadSliderToImgur(file3, "slider3");
    else
      slider3Url = document.getElementById("slider3Img").src;
    if (file4 !== undefined)
      await uploadSliderToImgur(file4, "slider4");
    else
      slider4Url = document.getElementById("slider4Img").src;

    // console.log("url1 " + slider1Url)
    // console.log("url2 " + slider2Url)
    // console.log("url3 " + slider3Url)
    // console.log("url4 " + slider4Url)

    const param = {
      banner_img_1: slider1Url,
      banner_img_2: slider2Url,
      banner_img_3: slider3Url,
      banner_img_4: slider4Url,
    }

    // console.log(JSON.stringify(param))
    fetch(process.env.REACT_APP_API_BASE_LINK + '/v1/fookchong/cms/updateBannerImages', {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
      },
      body: JSON.stringify(param),
    }).then(response => response.json())
      .then((usefulData) => {
        setShowSuccessModal(true);
      }).catch(function (error) {
        alert("發生錯誤, 請重新提交更新請求")
    })
  }

  return (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-blueGray-100">
        <nav className="absolute top-0 left-0 w-full z-10 bg-transparent md:flex-row md:flex-nowrap md:justify-start flex items-center p-4">
          <div className="w-full mx-autp items-center flex justify-between md:flex-nowrap flex-wrap md:px-10 px-4">
            {/* Brand */}
            <div
              className="text-white text-xl uppercase lg:inline-block font-semibold"
            >
              輪播版位
            </div>
          </div>
        </nav>
        {/* Header */}
        <HeaderWithoutStats />

        {
          (loading == true)
            ? <Loader />
            : <div className="px-4 md:px-10 mx-auto w-full m-12">
              <div>
                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6 w-full">
                  <div className="relative mx-auto w-108 max-h-96">
                    <div className="relative inline-block duration-300 ease-in-out w-full">
                      <div className="shadow p-4 rounded-lg bg-white">
                        <figure className="max-w-sm mt-4 ">
                          <img id="slider1Img" className="w-80 h-56 rounded-lg" src={data[0] || "https://images.pexels.com/photos/20787/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=350"} alt="image description"></img>
                          <figcaption className="mt-2 text-sm text-center text-gray-500 dark:text-gray-400">項目封面圖片</figcaption>
                          <div className="flex items-center justify-center mt-4">
                            <input onChange={e => coverImg_changed(e, "slider1")} id="slider1" type="file" accept=".png, .jpg, .jpeg" className="mt-4 focus:outline-none" name="projectCoverImg" />
                          </div>
                        </figure>
                      </div>
                    </div>
                  </div>

                  <div className="relative mx-auto w-108 max-h-96">
                    <div className="relative inline-block duration-300 ease-in-out w-full">
                      <div className="shadow p-4 rounded-lg bg-white">
                        <figure className="max-w-sm mt-4 ">
                          <img id="slider2Img" className="w-80 h-56 rounded-lg" src={data[1] || "https://images.pexels.com/photos/20787/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=350"} alt="image description"></img>
                          <figcaption className="mt-2 text-sm text-center text-gray-500 dark:text-gray-400">項目封面圖片</figcaption>
                          <div className="flex items-center justify-center mt-4">
                            <input onChange={e => coverImg_changed(e, "slider2")} id="slider2" type="file" accept=".png, .jpg, .jpeg" className="mt-4 focus:outline-none" name="projectCoverImg" />
                          </div>

                        </figure>
                      </div>
                    </div>
                  </div>

                  <div className="relative mx-auto w-108 max-h-96">
                    <div className="relative inline-block duration-300 ease-in-out w-full">
                      <div className="shadow p-4 rounded-lg bg-white">
                        <figure className="max-w-sm mt-4 ">
                          <img id="slider3Img" className="w-80 h-56 rounded-lg" src={data[2] || "https://images.pexels.com/photos/20787/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=350"} alt="image description"></img>
                          <figcaption className="mt-2 text-sm text-center text-gray-500 dark:text-gray-400">項目封面圖片</figcaption>
                          <div className="flex items-center justify-center mt-4">
                            <input onChange={e => coverImg_changed(e, "slider3")} id="slider3" type="file" accept=".png, .jpg, .jpeg" className="mt-4 focus:outline-none" name="projectCoverImg" />
                          </div>

                        </figure>
                      </div>
                    </div>
                  </div>

                  <div className="relative mx-auto w-108 max-h-96">
                    <div className="relative inline-block duration-300 ease-in-out w-full">
                      <div className="shadow p-4 rounded-lg bg-white">
                        <figure className="max-w-sm mt-4 ">
                          <img id="slider4Img" className="w-80 h-56 rounded-lg" src={data[3] || "https://images.pexels.com/photos/20787/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=350"} alt="image description"></img>
                          <figcaption className="mt-2 text-sm text-center text-gray-500 dark:text-gray-400">項目封面圖片</figcaption>
                          <div className="flex items-center justify-center mt-4">
                            <input onChange={e => coverImg_changed(e, "slider4")} id="slider4" type="file" accept=".png, .jpg, .jpeg" className="mt-4 focus:outline-none" name="projectCoverImg" />
                          </div>

                        </figure>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div className="flex items-center justify-center my-24">
                <button className="focus:outline-none bg-transparent hover:bg-indigo-500 text-indigo-700 font-semibold hover:text-white py-2 px-4 border border-indigo-500 hover:border-transparent rounded"
                  onClick={() => updateAllSlider()}
                >
                  更新
                </button>
              </div>
            </div>

        }
        {showSuccessModal ? (
          <>
            <div
              className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            >
              <div className="relative w-auto ">
                {/*content*/}
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  <div className="flex items-start justify-between p-2">

                    <button type="button" className="focus:outline-none text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                      onClick={() => {
                        setShowSuccessModal(false);
                        window.location.reload();
                      }}
                    >
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                    </button>
                  </div>

                  {/*body*/}
                  <div className="px-8 ">

                    <div className="mb-4 sm:flex">
                      <div className="flex items-center justify-center flex-none w-12 h-12 mx-auto bg-green-200 rounded-full">
                        <svg className="w-6 h-6 fill-current text-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z" /></svg>
                      </div>
                      <div className="text-center sm:ml-4 sm:text-left">
                        <h5 className="mt-2 text-lg font-medium text-gray-800">
                          成功更新!
                        </h5>

                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        ) : null}
      </div>

    </>
  );
}
